import { render } from "./AdminUploadPage.vue?vue&type=template&id=6ab6aa16"
import script from "./AdminUploadPage.vue?vue&type=script&lang=js"
export * from "./AdminUploadPage.vue?vue&type=script&lang=js"
script.render = render

export default script